import { __awaiter } from "tslib";
import { ConfigurationChangeEvent } from "@plansoft-configuration-renderer/events";
import { handleConfigurationEvent } from "../events/handleConfigurationEvent";
import { decrementOpenRequests, incrementOpenRequests, } from "../reducers/actions";
import { handleCfgStateResponse } from "./handleCfgStateResponse";
/**
 * Generic thunk action to keep standard operations DRY
 * - inject sessionid
 * - increment and decrement request counter
 * - set cfg state response
 *
 * @export
 * @template Request
 * @template Response
 * @param apiFunction
 * @param request
 * @returns The whole response, if additional data is needed
 */
export function cfgStateThunkAction(apiFunction) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        try {
            dispatch(incrementOpenRequests());
            // call api
            const response = yield apiFunction();
            // set response
            dispatch(handleCfgStateResponse(response));
            dispatch(handleConfigurationEvent(new ConfigurationChangeEvent(response.id)));
            return response;
        }
        finally {
            dispatch(decrementOpenRequests());
        }
    });
}
//# sourceMappingURL=cfgStateThunkAction.js.map